<div class="table-wrapper" [class]="tableClass">
    <ng-container *ngIf="!isFilterHidden">
        <div class="table-control" fxLayoutAlign="space-between center" fxLayout="row wrap">
            <div *ngIf="!shouldHideSearch" #search class="tbl-filter" fxFlex.gt-md="1 1 38%" fxFlex.gt-xs="1 1 100%">
                <mat-icon inline id="search-prefix" class="fp-icon-search" fxFlex="0 1 auto"></mat-icon>
                <clare-search
                    [placeholder]="placeholder"
                    fxFlex="1 1"
                    [initialValue]="initialQueryString"
                    (searchDataHandler)="onDataSearch($event)"
                ></clare-search>
                <mat-icon
                    id="search-suffix"
                    fxFlex="0 1 auto"
                    class="fp-icon-filter"
                    (click)="onDataRefresh()"
                    *ngIf="!shouldHideRefresh && isSearchSuffixIconShown"
                ></mat-icon>
            </div>
            <div fxFlex="1 1 auto">
                <ng-template #container></ng-template>
            </div>
            <mat-paginator
                *ngIf="!shouldHidePagination"
                [length]="dataSourceLength"
                [pageSize]="pageSize"
                [pageIndex]="pageIndex"
                [pageSizeOptions]="pageSizeOptions"
                [hidePageSize]="hidePageSize"
                (page)="pageEvent($event)"
            ></mat-paginator>
        </div>
    </ng-container>

    <div>
        <clare-table-custom-action
            *ngIf="isSeparatedAction"
            [selectedRow]="selectedRow"
            [tableActionOptions]="tableActionOptions"
            (selectRow)="selectRow($event)"
        ></clare-table-custom-action>
    </div>
    <ng-template #exportcsv></ng-template>
    <div class="hint-container" *ngIf="tableHint">
        <mat-hint class="table-hint">{{ tableHint }}</mat-hint>
    </div>
    <mat-card class="clare-table-container device-list mat-elevation-z">
        <mat-card-content>
            <clare-spinner *ngIf="isLoading; else isLoaded" [text]="spinnerText"></clare-spinner>
            <ng-template #isLoaded>
                <div class="scrollable-table">
                    <mat-table
                        attr.aria-label="Table view of {{ title }}"
                        #table
                        matSort
                        (matSortChange)="sortEvent($event)"
                        [dataSource]="tableData"
                        [trackBy]="trackById"
                    >
                        <ng-container [matColumnDef]="col" *ngFor="let col of columnsToDisplay; trackBy: trackByName">
                            <ng-container *ngIf="col !== 'deviceLowBattery' && col !== 'previewDealerLockout'; else noHeader">
                                <mat-header-cell [ngClass]="{ nosort: !col }" *matHeaderCellDef [mat-sort-header]="col">
                                    <span>{{ columns[col]?.displayName || columns[col] }}</span>
                                </mat-header-cell>
                            </ng-container>
                            <ng-template #noHeader>
                                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            </ng-template>
                            <mat-cell
                                *matCellDef="let row"
                                (click)="edit(row?.id || row)"
                                class=""
                                [ngClass]="{ 'selected-color': isRowSelected(row?.id) }"
                            >
                                <ng-container
                                    *ngIf="
                                        col !== 'select' &&
                                            col.indexOf('Status') === -1 &&
                                            col !== 'signalStrength' &&
                                            col !== 'action' &&
                                            col !== 'isOccupied' &&
                                            col !== 'deviceLowBattery' &&
                                            col !== 'previewDealerLockout';
                                        else specialtyColumn
                                    "
                                >
                                    <span
                                        *ngIf="!isMobileView; else mobileView"
                                        [innerHTML]="row[col] === null && shouldShowBlankCellDash ? '-' : row[col]"
                                    ></span>
                                    <ng-template #mobileView>
                                        <span>
                                            <clare-status-indicator *ngIf="col === 'name'" [status]="['', row?.onlineStatus[1]]">
                                            </clare-status-indicator>
                                            {{ row[col] }}
                                        </span>
                                    </ng-template>
                                </ng-container>
                                <ng-template #specialtyColumn>
                                    <span>
                                        <mat-checkbox
                                            class="list-item-checkbox"
                                            *ngIf="col === 'select'"
                                            (click)="preventClick($event)"
                                            (change)="selectRow(row)"
                                            [checked]="isRowSelected(row?.id)"
                                        >
                                        </mat-checkbox>
                                        <clare-status-indicator
                                            *ngIf="col.indexOf('Status') !== -1"
                                            [status]="row[col]"
                                        ></clare-status-indicator>
                                        <clare-status-indicator
                                            *ngIf="col.indexOf('isOccupied') !== -1"
                                            [status]="row[col] | occupationStatus"
                                        ></clare-status-indicator>
                                        <clare-signal-strength
                                            *ngIf="col === 'signalStrength'"
                                            [signalStrength]="row[col]"
                                        ></clare-signal-strength>
                                        <table-custom-action-container
                                            *ngIf="col === 'action'"
                                            [tableActionOptions]="tableActionOptions"
                                            [selectedRow]="row"
                                        ></table-custom-action-container>
                                        <ng-container *ngIf="col === 'deviceLowBattery'">
                                            <img *ngIf="row[col]" src="assets/images/low-battery.svg" alt="low battery icon" />
                                        </ng-container>
                                        <ng-container *ngIf="col === 'previewDealerLockout'">
                                            <div class="preview-lockout-btn-container">
                                                <button class="mat-stroked-button mat-button-base"(click)="row.method()">Preview</button>
                                            </div>
                                        </ng-container>
                                    </span>
                                </ng-template>
                            </mat-cell>
                        </ng-container>
                        <ng-container>
                            <tr
                                mat-header-row
                                *matHeaderRowDef="columnsToDisplay"
                                [class.invisible]="isDynamicBarAction && selectedRow"
                            ></tr>
                        </ng-container>
                        <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
                    </mat-table>
                </div>
            </ng-template>
        </mat-card-content>
    </mat-card>
</div>
